import { CommonModule, NgOptimizedImage } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterLink } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective, MaskitoPipe } from '@maskito/angular';

import { NgxEchartsDirective } from 'ngx-echarts';

import { AppWrapperComponent } from './components/app-wrapper/app-wrapper.component';
import { ChartComponent } from './components/chart/chart.component';
import { ContactCardContentComponent } from './components/contact-card-content/contact-card-content.component';
import { ContactCardHeaderComponent } from './components/contact-card-header/contact-card-header.component';
import { ContactCardComponent } from './components/contact-card/contact-card.component';
import { DatePickerModalComponent } from './components/date-picker-modal/date-picker-modal.component';
import { FluidLayoutComponent } from './components/fluid-layout/fluid-layout.component';
import { FooterContentComponent } from './components/footer-content/footer-content.component';
import { GenericComponent } from './components/generic/generic.component';
import { HeaderContentComponent } from './components/header-content/header-content.component';
import { HeaderComponent } from './components/header/header.component';
import { InnerContentComponent } from './components/inner-content/inner-content.component';
import { LeadStatusSelectorComponent } from './components/lead-status-selector/lead-status-selector.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { MapDefaultOptionsComponent } from './components/map-default-options/map-default-options.component';
import { MapSearchComponent } from './components/map-search/map-search.component';
import { NumericButtonsInputComponent } from './components/numeric-buttons-input/numeric-buttons-input.component';
import { PageContentComponent } from './components/page-content/page-content.component';
import { PaywallModalComponent } from './components/paywall-modal/paywall-modal.component';
import { PropertyNavigatorComponent } from './components/property-navigator/property-navigator.component';
import { SearchMenuComponent } from './components/search-menu/search-menu.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { TabsLayoutComponent } from './components/tabs-layout/tabs-layout.component';
import { UserPositionCenterButtonComponent } from './components/user-position-center-button/user-position-center-button.component';
import { UserPositionComponent } from './components/user-position/user-position.component';
import { WebLayoutComponent } from './components/web-layout/web-layout.component';
import { ErrorMessageDirective } from './directives/error-message.directive';
import { AddressPipe } from './pipes/address.pipe';
import { CompassAccuracyPipe } from './pipes/compass-accuracy.pipe';
import { DashIfEmptyPipe } from './pipes/dash-if-empty.pipe';
import { FilterWalkingFarmPropertiesPipe } from './pipes/filter-walking-farm-properties.pipe';
import { LeadStatusPipe } from './pipes/lead-status.pipe';
import { OwnerNamePipe } from './pipes/owner-name.pipe';
import { PercentagePipe } from './pipes/percentage.pipe';
import { RangeFilterTextPipe } from './pipes/range-filter-text.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { SurfacePipe } from './pipes/surface.pipe';
import { TimePipe } from './pipes/time.pipe';
import { UsdCurrencyPipe } from './pipes/usd-currency.pipe';

@NgModule({
  declarations: [
    AddressPipe,
    AppWrapperComponent,
    ChartComponent,
    CompassAccuracyPipe,
    SearchableSelectComponent,
    ContactCardComponent,
    ContactCardContentComponent,
    ContactCardHeaderComponent,
    DashIfEmptyPipe,
    DatePickerModalComponent,
    FilterWalkingFarmPropertiesPipe,
    FluidLayoutComponent,
    FooterContentComponent,
    GenericComponent,
    HeaderComponent,
    HeaderContentComponent,
    InnerContentComponent,
    LeadStatusPipe,
    LeadStatusSelectorComponent,
    MainLayoutComponent,
    MapDefaultOptionsComponent,
    MapSearchComponent,
    NumericButtonsInputComponent,
    OwnerNamePipe,
    PageContentComponent,
    PaywallModalComponent,
    PercentagePipe,
    PropertyNavigatorComponent,
    RangeFilterTextPipe,
    SearchMenuComponent,
    SurfacePipe,
    TabsLayoutComponent,
    TimePipe,
    UsdCurrencyPipe,
    UserPositionCenterButtonComponent,
    UserPositionComponent,
    WebLayoutComponent
  ],
  exports: [
    AddressPipe,
    AppWrapperComponent,
    ChartComponent,
    CompassAccuracyPipe,
    DashIfEmptyPipe,
    DatePickerModalComponent,
    FilterWalkingFarmPropertiesPipe,
    FluidLayoutComponent,
    FooterContentComponent,
    GenericComponent,
    HeaderComponent,
    HeaderContentComponent,
    SearchableSelectComponent,
    InnerContentComponent,
    LeadStatusPipe,
    LeadStatusSelectorComponent,
    MapDefaultOptionsComponent,
    MapSearchComponent,
    MaskitoPipe,
    NumericButtonsInputComponent,
    OwnerNamePipe,
    PageContentComponent,
    PercentagePipe,
    PropertyNavigatorComponent,
    RangeFilterTextPipe,
    SurfacePipe,
    TabsLayoutComponent,
    TimePipe,
    UsdCurrencyPipe,
    UserPositionCenterButtonComponent,
    UserPositionComponent,
    WebLayoutComponent
  ],
  imports: [
    CommonModule,
    GoogleMapsModule,
    IonicModule,
    MaskitoDirective,
    MaskitoPipe,
    NgOptimizedImage,
    NgxEchartsDirective,
    ReactiveFormsModule,
    RouterLink,
    SanitizeHtmlPipe,
    ErrorMessageDirective
  ],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())]
})
export class MiscModule {}
